








import { Component, Vue, Prop } from 'vue-property-decorator'

export type ApiType = 'document' | 'image' | 'dicom' | 'md'

@Component
export default class FileDownload extends Vue {
  @Prop({ default: '' }) fileName!: string
  @Prop({ default: '' }) type!: ApiType
  @Prop() patientId?: number
  @Prop() fileId?: number

  message = 'ファイルをダウンロードします。'

  mounted() {
    this.download()
  }
  async downloadImage() {
    if (this.patientId == undefined || this.fileId == undefined) return ''
    const res = await this.$api.image.fetchImage({
      patientId: this.patientId,
      imageId: this.fileId
    })
    return window.URL.createObjectURL(res)
  }
  async downloadDicom() {
    if (this.patientId == undefined || this.fileId == undefined) return ''
    const res = await this.$api.dicom.fetchImage({
      patientId: this.patientId,
      dicomId: this.fileId
    })
    return window.URL.createObjectURL(res)
  }
  async downloadDocument() {
    if (this.patientId == undefined || this.fileId == undefined) return ''
    const res = await this.$api.document.fetchFile({
      patientId: this.patientId,
      documentId: this.fileId
    })
    return window.URL.createObjectURL(res)
  }
  async downloadMedicationInstruction() {
    if (this.patientId == undefined || this.fileId == undefined) return ''
    const res = await this.$api.medicationInstruction.fetchFile({
      patientId: this.patientId
    })
    return window.URL.createObjectURL(res)
  }
  async download() {
    if (!this.type || this.patientId == undefined || this.fileId == undefined) {
      this.message = '無効なURLです。'
    }
    let url = ''
    switch (this.type) {
      case 'image':
        url = await this.downloadImage()
        break
      case 'dicom':
        url = await this.downloadDicom()
        break
      case 'document':
        url = await this.downloadDocument()
        break
      case 'md':
        url = await this.downloadMedicationInstruction()
        break
    }
    const a = document.createElement('a')
    a.style.opacity = '0'
    document.body.appendChild(a)
    a.download = this.fileName || ''
    a.href = url
    a.click()
    a.remove()
    setTimeout(() => {
      URL.revokeObjectURL(url)
    }, 100)
  }
}
